module.exports = __webpack_public_path__ + "static/img/5.a6cf75f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/sp/5.png
// module id = 2bxa
// module chunks = 0